import React from 'react';

export const NotFoundPage = () => <div>404 Not found</div>
